import React from "react";

const SVG = ({
    style = {},
    fill = "#000",
    width = "10px",
    height = "17px",
    className = "",
    viewBox = "0 0 24 24"
}) => (
        <svg
            width={height}
            style={style}
            height={height}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
            className={`svg-icon ${className || ""}`}
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <path
                fill={fill}
                d="M13.0177379,20.6347656 C13.3302379,20.6347656 13.6329723,20.5078125 13.8966442,20.2441406 L20.3028942,13.8574219 C20.5470348,13.6132812 20.6935192,13.2714844 20.6935192,12.9296875 C20.6935192,12.5878906 20.5470348,12.2363281 20.3028942,12.0019531 L13.9161754,5.61523438 C13.6427379,5.34179688 13.3302379,5.21484375 13.0177379,5.21484375 C12.2950817,5.21484375 11.7872692,5.73242188 11.7872692,6.40625 C11.7872692,6.77734375 11.9435192,7.0703125 12.1681286,7.3046875 L14.3849254,9.53125 L16.8556286,11.796875 L14.6583629,11.6796875 L3.22281605,11.6796875 C2.45133168,11.6796875 1.93375355,12.1875 1.93375355,12.9296875 C1.93375355,13.671875 2.45133168,14.1796875 3.22281605,14.1796875 L14.6583629,14.1796875 L16.8556286,14.0527344 L14.3849254,16.328125 L12.1681286,18.5449219 C11.9435192,18.7792969 11.7872692,19.0722656 11.7872692,19.4433594 C11.7872692,20.1269531 12.2950817,20.6347656 13.0177379,20.6347656 Z" 
            />
        </svg>
    );

export default SVG;
